export default __webpack_public_path__ + "static/bannerPubliMBCL-3ddfee65c36e6e5a4966789421c3da4b.png";